__turbopack_context__.v({
  "promo-ribbon-text": "TNpLWW_promo-ribbon-text",
  "rgg-promo": "TNpLWW_rgg-promo",
  "ribbon-promo-container": "TNpLWW_ribbon-promo-container",
  "travel-promo": "TNpLWW_travel-promo",
  "with-plane": "TNpLWW_with-plane",
});
